/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Autocomplete } from "@material-ui/lab";
import { format } from "date-fns/esm";
import ListBox from "components/ListBox";

export default function Lookup({
  controlNo,
  name,
  value,
  dataSet,
  dataValue,
  displayValue,
  items,
  values,
  setParameter,
}) {
  const parseData = () => {
    const newData = [];
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        newData.push({
          text: items[i]?.toString(),
          value: values[i]?.toString(),
        });
      }
    } else if (dataSet && dataSet.data) {
      dataSet.data.forEach((element) => {
        newData.push({
          text: element[`${displayValue}`]?.toString(),
          value: element[`${dataValue}`]?.toString(),
        });
      });
    }
    return newData;
  };

  function getDefaultValue(dataArray) {
    let dt = dataArray;
    if (!dt || dt.length === 0) return null;
    if (Number.isInteger(value)) {
      let index = +value;
      index = index >= dt.length ? dt.length - 1 : index;
      index = index < 0 ? 0 : index;
      return dt[index];
    } else {
      switch ((value ?? "").toLowerCase()) {
        case "first":
          return dt[0];
        case "last":
          return dt[dt.length - 1];
        case "thismonth": {
          let thismonth = format(new Date(), "yyyy-MM");
          let findIndexM = dt.findIndex((i) => i.value === thismonth);
          return findIndexM >= 0 ? dt[findIndexM] : dt[0];
        }
        case "thisyear": {
          let thisyear = format(new Date(), "yyyy");
          let findIndexY = dt.findIndex((i) => i.value === thisyear);
          return findIndexY >= 0 ? dt[findIndexY] : dt[0];
        }
        default:
          return dt[0];
      }
    }
  }

  const [data, setData] = useState(() => parseData());
  const [selectedValue, setSelectedValue] = useState(() => {
    const initial = parseData();
    return initial.length > 0 ? getDefaultValue(initial) : null;
  });

  const isLoading = items.length === 0 && (!dataSet || !dataSet.data);

  function checkNewData(newData) {
    if (newData && newData.length !== 0) {
      const item = getDefaultValue(newData);
      setSelectedValue(item);
      setParameter(controlNo, name, item?.value);
    } else {
      setSelectedValue(null);
      setParameter(controlNo, name, "");
    }
  }

  useEffect(() => {
    const newData = parseData();
    setData(newData);
    checkNewData(newData);
  }, [items, values, dataSet, value, dataValue, displayValue]);

  return (
    <Autocomplete
      //ref = {(e)=> refKey.current[refId] = e}
      id={name}
      name={name}
      disabled={isLoading}
      disableClearable
      disableListWrap
      ListboxComponent={ListBox}
      options={data}
      getOptionLabel={(option) => option?.text ?? ""}
      getOptionSelected={(option, val) => option?.value === val?.value}
      renderInput={(params) => (
        <TextField
          //inputRef={(element) => (refKey.current[refId] = element)}
          //name={name}
          {...params}
          label=""
          margin="normal"
          fullWidth
          placeholder={isLoading ? "Loading..." : ""}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      value={selectedValue ?? null}
      onChange={(e, newValue) => {
        e.preventDefault();
        setSelectedValue(newValue);
        setParameter(controlNo, name, newValue?.value);
      }}
    />
  );
}
